module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Model-Q-1116.a243d08e.jpg";